import React, {FC, useState} from 'react';
import messages from '../messages';
import supplierOrderColumns from './columns';
import CollapseTable from 'components/collapse-table/collapse-table';
import {useTranslation} from 'react-i18next';
import {Button} from 'reactstrap';
import {ObjectId} from 'types/object-id';

interface Props {
  id?: ObjectId;
}

const SupplierOrderTable: FC<Props> = props => {
  const {id} = props;
  const {t} = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const filterDAte = [
    new Date('2015/01/01').toISOString(),
    new Date().toISOString(),
  ].join(',');

  return (
    <div>
      <Button color="light" onClick={toggle} className="mb-3 w-100">
        {t(...messages.supplierOrder())}
      </Button>
      <CollapseTable
        isOpen={isOpen}
        columns={supplierOrderColumns}
        url={`orders?type=SUPPLIER&filter[variant_id]=${id}&limit=10&filter[order_date]=${filterDAte}&for_stats=true`}
        name="directory-supplier-orders"
      />
    </div>
  );
};

export default SupplierOrderTable;
